import cookieStorage from '../utilities/cookie_storage';
import { COOKIE_KEYS } from '../constants';

const useUserInfo = () => ({
  userId: cookieStorage.getItem(COOKIE_KEYS.USER_ID),
  userType: cookieStorage.getItem(COOKIE_KEYS.USER_TYPE),
  userName: cookieStorage.getItem(COOKIE_KEYS.USER_NAME),
  userEmail: cookieStorage.getItem(COOKIE_KEYS.EMAIL) || '',
  roleLevel: Number(cookieStorage.getItem(COOKIE_KEYS.ROLE_LEVEL)),
  roleID: cookieStorage.getItem(COOKIE_KEYS.ROLE_ID),
  roleName: cookieStorage.getItem(COOKIE_KEYS.ROLE_NAME),
  roleType: cookieStorage.getItem(COOKIE_KEYS.ROLE_TYPE),
  assignedAccountManagerID: cookieStorage.getItem(COOKIE_KEYS.ASSIGNED_ACCOUNT_MANAGER_ID),
  token: cookieStorage.getItem(COOKIE_KEYS.TOKEN),
  isLastLevelInClientLevel: JSON.parse(cookieStorage.getItem(COOKIE_KEYS.IS_LAST_LEVEL_IN_CLIENT_LEVEL)) || false,
  isLastLevelInOrderLevel: JSON.parse(cookieStorage.getItem(COOKIE_KEYS.IS_LAST_LEVEL_IN_ORDER_LEVEL)) || false,
  lockEnabled: cookieStorage.getItem(COOKIE_KEYS.LOCK_ENABLED) === 'true',
});

export default useUserInfo;
